<template>
  <div class="home-view">

    <!-- HERO -->
    <section class="hero">
      <div class="container">
        <div class="hero-center">
          <h1>Defekte Fitnessgeräte sofort erkennen – bevor Mitglieder kündigen.</h1>
          <p>Mitglieder melden Geräteprobleme direkt per QR-Code. Fixtronic erkennt Defekte sofort und organisiert Wartungen automatisch.</p>
          <a href="https://link.facetronic.de/fixtronic" class="cta-button" target="_blank">Kostenlose Live-Demo buchen</a>
          <div class="hero-trust">
            <span class="hero-trust-item">Ab 29 € / Monat</span>
            <span class="hero-trust-sep">·</span>
            <span class="hero-trust-item">Keine App nötig</span>
            <span class="hero-trust-sep">·</span>
            <span class="hero-trust-item">In Minuten startklar</span>
          </div>
        </div>
        <div class="hero-image">
          <img src="@/assets/ida-hero.png" alt="Fixtronic Dashboard" />
        </div>
      </div>
    </section>

    <!-- VERGLEICH -->
    <section class="comparison">
      <div class="container">
        <span class="label">Fixtronic im Vergleich</span>
        <h2>Warum Fitnessstudios Fixtronic nutzen</h2>
        <div class="comparison-grid">
          <div class="col col-without">
            <h3>Ohne Fixtronic</h3>
            <ul>
              <li><span class="x">✕</span> Defekte bleiben tagelang unbemerkt</li>
              <li><span class="x">✕</span> Meldungen per Zettel, WhatsApp oder mündlich</li>
              <li><span class="x">✕</span> Kein Überblick über offene Probleme</li>
              <li><span class="x">✕</span> Wartungen werden vergessen</li>
              <li><span class="x">✕</span> Mitglieder sind frustriert und kündigen</li>
            </ul>
          </div>
          <div class="col col-with">
            <h3>Mit Fixtronic</h3>
            <ul>
              <li><span class="check">✓</span> Defekte werden sofort per QR-Code gemeldet</li>
              <li><span class="check">✓</span> Alle Meldungen zentral im Dashboard</li>
              <li><span class="check">✓</span> Voller Überblick über alle Geräte und Status</li>
              <li><span class="check">✓</span> Automatische Wartungserinnerungen</li>
              <li><span class="check">✓</span> Zufriedene Mitglieder durch funktionierende Geräte</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURE 1 -->
    <section class="feature bg-alt">
      <div class="container">
        <div class="feature-row">
          <div class="feature-img">
            <img src="@/assets/fixtronic-feature3.png" alt="Defektmeldung per QR-Code auf dem Smartphone" />
          </div>
          <div class="feature-text">
            <span class="label">Erste Funktion</span>
            <h2>Defekte Geräte melden in 5 Sekunden</h2>
            <p>Mitglieder scannen einfach den QR-Code am Gerät und melden das Problem sofort.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURE 2 -->
    <section class="feature">
      <div class="container">
        <div class="feature-row reverse">
          <div class="feature-img">
            <img src="@/assets/fixtronic-feature1.png" alt="Fixtronic Geräte-Dashboard" />
          </div>
          <div class="feature-text">
            <span class="label">Zweite Funktion</span>
            <h2>Alle Geräte und Probleme auf einen Blick.</h2>
            <p>Fixtronic zeigt sofort, welche Geräte Probleme haben, welche Wartungen anstehen und was bereits erledigt ist.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURE 3 -->
    <section class="feature bg-alt">
      <div class="container">
        <div class="feature-row">
          <div class="feature-img">
            <img src="@/assets/fixtronic-comparison.png" alt="Fixtronic Wartungsintervall planen" />
          </div>
          <div class="feature-text">
            <span class="label">Dritte Funktion</span>
            <h2>Wartungen planen, bevor Geräte ausfallen</h2>
            <p>Fixtronic erinnert automatisch an Wartungen, bevor Geräte ausfallen.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- PRICING + TRUST -->
    <section class="pricing bg-accent">
      <div class="container">
        <span class="label">Transparent &amp; fair</span>
        <h2>Ab 29 € pro Monat und Studio</h2>
        <p class="pricing-sub">In nur 15 Minuten zeigen wir Ihnen, wie Fixtronic Geräteprobleme erkennt und Wartungen organisiert.</p>
        <div class="trust-row">
          <div class="trust-item">
            <svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
            <span>Keine Einrichtungskosten</span>
          </div>
          <div class="trust-item">
            <svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
            <span>Keine Vertragsbindung</span>
          </div>
          <div class="trust-item">
            <svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
            <span>Made in Germany</span>
          </div>
        </div>
        <a href="https://link.facetronic.de/fixtronic" class="cta-button" target="_blank">Live-Demo vereinbaren</a>
      </div>
    </section>

    <!-- EINRICHTUNG -->
    <section class="setup bg-alt">
      <div class="container">
        <span class="label">Einfache Einrichtung</span>
        <h2>Das einfachste Wartungssystem für Fitnessstudios</h2>
        <p class="setup-sub">Fixtronic ist schnell eingerichtet und sofort einsatzbereit – ganz ohne Schulung oder technische Vorkenntnisse.</p>
        <div class="steps">
          <div class="step">
            <span class="step-num">1</span>
            <h3>Geräte anlegen</h3>
            <p>Lege alle Geräte, die du verwalten möchtest, zentral im Dashboard an – übersichtlich und strukturiert.</p>
          </div>
          <div class="step">
            <span class="step-num">2</span>
            <h3>QR-Codes zuweisen</h3>
            <p>Bringe den Fixtronic QR-Code am jeweiligen Gerät an und verknüpfe ihn im Dashboard. Ab sofort können Defekte direkt am Gerät gemeldet werden.</p>
          </div>
          <div class="step">
            <span class="step-num">3</span>
            <h3>Überblick behalten</h3>
            <p>Sobald ein Mitarbeiter oder Mitglied ein Problem meldet, erscheint es automatisch im Dashboard – inklusive Status und Verlauf.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section class="faq">
      <div class="container faq-container">
        <h2>Häufig gestellte Fragen</h2>
        <div class="faq-list">
          <div v-for="(item, index) in faqItems" :key="index" class="faq-item" :class="{ open: item.open }">
            <button class="faq-question" @click="toggleFaq(index)">
              <span>{{ item.question }}</span>
              <span class="faq-icon">{{ item.open ? '−' : '+' }}</span>
            </button>
            <div class="faq-answer" v-show="item.open">
              <p>{{ item.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FINALER CTA -->
    <section class="final-cta bg-accent">
      <div class="container">
        <h2>Bereit für stressfreie Gerätewartung?</h2>
        <p>Starten Sie jetzt – bereits ab 29 € pro Monat und Studio.</p>
        <a href="https://link.facetronic.de/fixtronic" class="cta-button" target="_blank">Kostenlose Live-Demo buchen</a>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      faqItems: [
        {
          question: 'Wie funktioniert die Defektmeldung per QR-Code?',
          answer: 'Jedes Gerät in Ihrem Studio erhält einen eigenen QR-Code. Mitglieder oder Mitarbeiter scannen den Code mit dem Smartphone und können das Problem in wenigen Sekunden beschreiben und melden — ganz ohne App oder Login.',
          open: false
        },
        {
          question: 'Brauche ich eine App für Fixtronic?',
          answer: 'Nein. Fixtronic ist komplett webbasiert. Mitglieder melden Defekte über den QR-Code im Browser, Sie verwalten alles über das Fixtronic Dashboard — ebenfalls im Browser. Keine App-Installation nötig.',
          open: false
        },
        {
          question: 'Was kostet Fixtronic?',
          answer: 'Fixtronic startet ab 29 € pro Monat und Studio. Es gibt keine Einrichtungskosten und keine versteckten Gebühren. In der Live-Demo besprechen wir gerne das passende Paket für Ihre Anforderungen.',
          open: false
        },
        {
          question: 'Wie schnell kann ich Fixtronic einrichten?',
          answer: 'Fixtronic ist in wenigen Minuten einsatzbereit. Sie legen Ihre Geräte im Dashboard an, drucken die QR-Codes aus und bringen sie an den Geräten an — fertig. Keine Schulung und keine technischen Vorkenntnisse nötig.',
          open: false
        },
        {
          question: 'Kann ich mehrere Studios verwalten?',
          answer: 'Ja. Mit einem einzigen Fixtronic-Konto können Sie die Geräte mehrerer Standorte verwalten — übersichtlich getrennt nach Studio.',
          open: false
        },
        {
          question: 'Wer kann Defekte melden?',
          answer: 'Jeder, der den QR-Code scannt — Mitglieder, Trainer oder Mitarbeiter. Es ist kein Login oder Account erforderlich. Die Meldung landet sofort im Dashboard.',
          open: false
        }
      ]
    };
  },
  methods: {
    toggleFaq(index) {
      this.faqItems[index].open = !this.faqItems[index].open;
    }
  }
}
</script>

<style scoped>
/* ---- SHARED ---- */
.label {
  display: block;
  text-align: center;
  color: var(--color-primary);
  font-weight: 600;
  font-size: 0.85em;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
}

h2 {
  text-align: center;
  font-size: 2.2em;
  margin-bottom: 16px;
}

/* ---- HERO ---- */
.hero {
  padding-top: 140px;
  padding-bottom: 64px;
  background: linear-gradient(180deg, var(--color-primary-bg) 0%, var(--color-background) 100%);
}

.hero-center {
  text-align: center;
  max-width: 680px;
  margin: 0 auto 48px;
}

.hero-center h1 {
  font-size: 3em;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
}

.hero-center p {
  font-size: 1.15em;
  color: var(--color-text-muted);
  line-height: 1.7;
  margin-bottom: 32px;
}

.hero-trust {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--color-text-muted);
  font-size: 0.88em;
}

.hero-trust-sep {
  opacity: 0.4;
}

.hero-image {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

.hero-image img {
  max-width: 100%;
  height: auto;
}

/* ---- COMPARISON ---- */
.comparison {
  background: var(--color-background);
}

.comparison-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 840px;
  margin: 32px auto 0;
}

.col {
  border-radius: var(--border-radius-lg);
  padding: 36px 28px;
}

.col-without {
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.col-with {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.col h3 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.2em;
}

.col-without h3 { color: #dc2626; }
.col-with h3 { color: #16a34a; }

.col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.col ul li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
  line-height: 1.5;
  font-size: 0.95em;
}

.col ul li:last-child { margin-bottom: 0; }

.x { color: #dc2626; font-weight: 700; flex-shrink: 0; }
.check { color: #16a34a; font-weight: 700; flex-shrink: 0; }

/* ---- FEATURES ---- */
.feature {
  padding-top: 72px;
  padding-bottom: 72px;
}

.feature-row {
  display: flex;
  align-items: center;
  gap: 56px;
  max-width: 1000px;
  margin: 0 auto;
}

.feature-row.reverse {
  flex-direction: row-reverse;
}

.feature-img {
  flex: 1;
  min-width: 0;
}

.feature-img img {
  width: 100%;
  height: auto;
  border-radius: var(--border-radius-lg);
}

.feature-text {
  flex: 1;
  min-width: 0;
}

.feature-text .label {
  text-align: left;
}

.feature-text h2 {
  text-align: left;
  font-size: 1.8em;
  margin-bottom: 12px;
}

.feature-text p {
  color: var(--color-text-muted);
  font-size: 1.05em;
  line-height: 1.7;
  margin: 0;
}

/* ---- PRICING + TRUST ---- */
.pricing {
  text-align: center;
  padding: 72px 24px;
}

.pricing h2 {
  font-size: 2.4em;
  margin-bottom: 12px;
}

.pricing-sub {
  color: var(--color-text-muted);
  font-size: 1.1em;
  line-height: 1.7;
  max-width: 520px;
  margin: 0 auto 32px;
}

.trust-row {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95em;
  font-weight: 500;
  color: var(--color-secondary);
}

.trust-item svg {
  color: #16a34a;
  flex-shrink: 0;
}

/* ---- SETUP / STEPS ---- */
.setup {
  text-align: center;
}

.setup-sub {
  color: var(--color-text-muted);
  font-size: 1.05em;
  line-height: 1.7;
  max-width: 580px;
  margin: -4px auto 40px;
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 960px;
  margin: 0 auto;
}

.step {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-lg);
  padding: 32px 24px;
}

.step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--color-primary);
  color: white;
  font-weight: 700;
  margin-bottom: 16px;
}

.step h3 {
  font-size: 1.1em;
  margin-bottom: 8px;
}

.step p {
  color: var(--color-text-muted);
  font-size: 0.93em;
  line-height: 1.65;
  margin: 0;
}

/* ---- FAQ ---- */
.faq {
  background: var(--color-background);
}

.faq-container {
  max-width: 760px;
}

.faq-list {
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.faq-item {
  border-bottom: 1px solid var(--color-border);
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  width: 100%;
  padding: 20px 24px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: inherit;
  font-size: 1.05em;
  font-weight: 500;
  color: var(--color-secondary);
  text-align: left;
  transition: background-color 0.2s ease;
}

.faq-question:hover {
  background-color: var(--color-background-alt);
}

.faq-icon {
  font-size: 1.4em;
  color: var(--color-primary);
  font-weight: 600;
  flex-shrink: 0;
  margin-left: 16px;
}

.faq-answer {
  padding: 0 24px 20px;
  color: var(--color-text-muted);
  line-height: 1.7;
}

.faq-answer p {
  margin: 0;
}

/* ---- FINAL CTA ---- */
.final-cta {
  text-align: center;
  padding: 72px 24px;
}

.final-cta h2 {
  margin-bottom: 8px;
}

.final-cta p {
  color: var(--color-text-muted);
  font-size: 1.1em;
  margin: 0 auto 28px;
}

/* ---- RESPONSIVE ---- */
@media (max-width: 768px) {
  .hero { padding-top: 110px; }
  .hero-center h1 { font-size: 2.2em; }

  .comparison-grid { grid-template-columns: 1fr; }

  .feature-row,
  .feature-row.reverse {
    flex-direction: column;
    text-align: center;
    gap: 28px;
  }
  .feature-img { max-width: 420px; margin: 0 auto; }
  .feature-text .label,
  .feature-text h2 { text-align: center; }
  .feature-text p { margin: 0 auto; }

  .trust-row { gap: 16px; }

  .steps { grid-template-columns: 1fr; max-width: 400px; }
}
</style>
